import { FormProvider } from 'react-hook-form';
import { ReadUser } from '@tinct/core-api-models';
import { useDisableMfa } from '@tinct/core-api';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tinct/web-components';
import { handleApiError } from '@tinct/web-form';
import { toast } from 'sonner';
import { useMfaFreshProofForm } from '../../hooks/use-mfa-fresh-proof-form';
import { MfaFreshProofFields } from './mfa-fresh-proof-fields';

type DisableMfaModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  user: ReadUser;
};

export const DisableMfaModal = ({ open, onOpenChange, user }: DisableMfaModalProps) => {
  const { form, toRequest, allowCode } = useMfaFreshProofForm(user);

  const disableMfa = useDisableMfa({
    onSuccess: () => {
      toast.success('Two-factor authentication disabled');
      onOpenChange(false);
    },
    onError: (error) => handleApiError(error, form),
  });

  const handleSubmit = form.handleSubmit((data) => {
    disableMfa.mutate({ userId: user.id as string, data: toRequest(data) });
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <form id="disable-mfa-form" onSubmit={handleSubmit} className="contents">
          <FormProvider {...form}>
            <DialogHeader>
              <DialogTitle>Disable two-factor authentication</DialogTitle>
              <DialogDescription>
                Sign-in will no longer ask for a code, and your recovery codes stop working. Confirm
                it is you first.
              </DialogDescription>
            </DialogHeader>

            <MfaFreshProofFields allowCode={allowCode} />

            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
                Cancel
              </Button>
              <Button
                type="submit"
                form="disable-mfa-form"
                variant="destructive"
                isLoading={disableMfa.isPending}
              >
                Disable
              </Button>
            </DialogFooter>
          </FormProvider>
        </form>
      </DialogContent>
    </Dialog>
  );
};
